import React from 'react';
import { Briefcase, Calendar, MapPin } from 'lucide-react';
import { experience } from '../data/mock';

const Experience = () => {
  return (
    <section id="experience" className="py-24 bg-black relative">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-16">
            <span className="text-gray-500 text-sm font-mono tracking-wider uppercase">Career Journey</span>
            <h2 className="text-4xl md:text-5xl font-bold text-white mt-4 mb-6">
              Work Experience
            </h2>
            <div className="w-20 h-1 bg-white mx-auto"></div>
          </div>

          {/* Timeline */}
          <div className="relative">
            {/* Timeline line */}
            <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 h-full w-0.5 bg-gray-800"></div>

            {experience.map((job, index) => (
              <div key={job.id} className="relative mb-12 md:mb-16">
                {/* Timeline dot */}
                <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 w-4 h-4 bg-white rounded-full border-4 border-black z-10"></div>

                {/* Content */}
                <div className={`md:w-1/2 ${index % 2 === 0 ? 'md:pr-12 md:text-right md:ml-auto' : 'md:pl-12'}`}>
                  <div className="bg-gray-950 border border-gray-800 rounded-xl p-6 hover:border-gray-700 transition-all duration-300">
                    {/* Header */}
                    <div className="mb-4">
                      {job.type === 'current' && (
                        <span className="inline-block px-3 py-1 bg-white text-black text-xs font-semibold rounded-full mb-3">
                          CURRENT
                        </span>
                      )}
                      <h3 className="text-2xl font-bold text-white mb-2">{job.role}</h3>
                      <div className="flex items-center gap-2 text-gray-400 mb-2 flex-wrap">
                        <Briefcase className="w-4 h-4" />
                        <span className="font-semibold">{job.company}</span>
                      </div>
                      <div className="flex items-center gap-4 text-gray-500 text-sm flex-wrap">
                        <div className="flex items-center gap-1">
                          <Calendar className="w-4 h-4" />
                          <span>{job.period}</span>
                        </div>
                        <div className="flex items-center gap-1">
                          <MapPin className="w-4 h-4" />
                          <span>{job.location}</span>
                        </div>
                      </div>
                    </div>

                    {/* Description */}
                    <p className="text-gray-400 mb-4 leading-relaxed">
                      {job.description}
                    </p>

                    {/* Highlights */}
                    <div className="space-y-2">
                      {job.highlights.map((highlight, idx) => (
                        <div key={idx} className="flex items-start gap-2 text-gray-500 text-sm">
                          <span className="text-white mt-1.5">•</span>
                          <span>{highlight}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
